import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const ClientSection = () => {
  const centerRef = useRef(null);

  useEffect(() => {
    // Center element ka floating aur rotating animation
    gsap.to(centerRef.current, {
      y: -20, // Thoda upar niche move hoga
      rotation: 5, // Halki rotation
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });
  }, []);

  // Ye aapke clients ke logos ka array hai
  const clients = Array(12).fill("Logo"); 

  return (
    <div className="clients-container">
      <div className="grid-wrapper">
        {/* Logos ko map karke dikhayenge */}
        {clients.map((client, index) => (
          <div key={index} className={`client-card card-${index + 1}`}>
            <div className="logo-placeholder">{client}</div>
          </div>
        ))}

        {/* Beech wala Moving Element */}
        <div className="center-element" ref={centerRef}>
          <div className="glass-box">
            <h2>CLIENTS WHO TRUST US</h2>
          </div>
          {/* Aap yahan wo 3D ring wali image laga sakte ho */}
          <div className="bg-rings"></div>
        </div>
      </div>
    </div>
  );
};

export default ClientSection;